import { PdfColor } from '../../pdf/pdf';
import { BackScreenBase } from './BackScreenBase';

export class BackScreen__Blue extends BackScreenBase {
  backgroundColor = PdfColor.fromRgb(0, 120, 200);
  genName = 'Image.BackScreen__Blue';
}
